export const UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING = 'UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING'
export const UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_FAILED =
  'UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_FAILED'
export const UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_SUCCEEDED =
  'UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_SUCCEEDED'
